module.exports = __webpack_public_path__ + "img/three_number.efa6b36a.svg";